import jQuery from "jquery-deferred";
import jqueryFunction from "./jquery-function";
import ajax from "./ajax";

const jqueryObj = jQuery.extend(jqueryFunction, jQuery, {
  defaultAjaxHeaders: null,
  ajax: (...args) => {
    // Merge defaultAjaxHeaders with any headers passed in the options
    const options = args[0];
    const headers = {
      ...jqueryObj.defaultAjaxHeaders,
      ...options.headers
    };
    return ajax(headers, ...args);
  },
  inArray: (item, arr) => arr.indexOf(item),
  trim: str => str && str.trim(),
  isEmptyObject: obj => !obj || Object.keys(obj).length === 0,
  makeArray: arr => [].slice.call(arr, 0),
  support: {
    cors: true,
  },
  param: source => {
    let array = [];
    for (var key in source) {
      array.push(encodeURIComponent(key) + "=" + encodeURIComponent(source[key]));
    }
    return array.join("&");
  },
});

export default jqueryObj;
